<template>
    <div style="background-color: #1EB11A; height: 100vh; width: 100vw">
      <loading v-if="displayLoading"></loading>
      <img src="https://storage.googleapis.com/waltily-prod/elancotw/inline_open_0415.jpg" alt="" class="w-100" @click="() => goto()">
    </div>
  </template>

  <script>
  import liff from "@line/liff";

  export default {
    data() {
      return {
        displayLoading: true,
      };
    },
    mounted() {
      this.init();
    },
    methods: {
      async init() {
        // 如果已經透過 LIFF Client 開啟，則直接導去 Elanco 活動頁
        if (liff.isInClient()) {
          this.$router.push({
            name: "LiffProjElanco",
            params: this.$route.params,
            query: this.$route.query
          });
          return;
        }

        this.displayLoading = false;
      },
      goto() {
        const liffId = this.$store.getters['liffGeneral/liffId'];
        window.location.href = `https://liff.line.me/${liffId}/proj/elanco/${this.$route.params.code}?event_code=elancotw2025`;
      }
    },
  };
  </script>
